export default [
  {
    value: 'AL',
    text: 'Alabama (AL)'
  },
  {
    value: 'AK',
    text: 'Alaska (AK)'
  },
  {
    value: 'AZ',
    text: 'Arizona (AZ)'
  },
  {
    value: 'AR',
    text: 'Arkansas (AR)'
  },
  {
    value: 'CA',
    text: 'California (CA)'
  },
  {
    value: 'CO',
    text: 'Colorado (CO)'
  },
  {
    value: 'CT',
    text: 'Connecticut (CT)'
  },
  {
    value: 'DE',
    text: 'Delaware (DE)'
  },
  {
    value: 'DC',
    text: 'District Of Columbia (DC)'
  },
  {
    value: 'FL',
    text: 'Florida (FL)'
  },
  {
    value: 'GA',
    text: 'Georgia (GA)'
  },
  {
    value: 'HI',
    text: 'Hawaii (HI)'
  },
  {
    value: 'ID',
    text: 'Idaho (ID)'
  },
  {
    value: 'IL',
    text: 'Illinois (IL)'
  },
  {
    value: 'IN',
    text: 'Indiana (IN)'
  },
  {
    value: 'IA',
    text: 'Iowa (IA)'
  },
  {
    value: 'KS',
    text: 'Kansas (KS)'
  },
  {
    value: 'KY',
    text: 'Kentucky (KY)'
  },
  {
    value: 'LA',
    text: 'Louisiana (LA)'
  },
  {
    value: 'ME',
    text: 'Maine (ME)'
  },
  {
    value: 'MD',
    text: 'Maryland (MD)'
  },
  {
    value: 'MA',
    text: 'Massachusetts (MA)'
  },
  {
    value: 'MI',
    text: 'Michigan (MI)'
  },
  {
    value: 'MN',
    text: 'Minnesota (MN)'
  },
  {
    value: 'MS',
    text: 'Mississippi (MS)'
  },
  {
    value: 'MO',
    text: 'Missouri (MO)'
  },
  {
    value: 'MT',
    text: 'Montana (MT)'
  },
  {
    value: 'NE',
    text: 'Nebraska (NE)'
  },
  {
    value: 'NV',
    text: 'Nevada (NV)'
  },
  {
    value: 'NH',
    text: 'New Hampshire (NH)'
  },
  {
    value: 'NJ',
    text: 'New Jersey (NJ)'
  },
  {
    value: 'NM',
    text: 'New Mexico (NM)'
  },
  {
    value: 'NY',
    text: 'New York (NY)'
  },
  {
    value: 'NC',
    text: 'North Carolina (NC)'
  },
  {
    value: 'ND',
    text: 'North Dakota (ND)'
  },
  {
    value: 'OH',
    text: 'Ohio (OH)'
  },
  {
    value: 'OK',
    text: 'Oklahoma (OK)'
  },
  {
    value: 'OR',
    text: 'Oregon (OR)'
  },
  {
    value: 'PA',
    text: 'Pennsylvania (PA)'
  },
  {
    value: 'RI',
    text: 'Rhode Island (RI)'
  },
  {
    value: 'SC',
    text: 'South Carolina (SC)'
  },
  {
    value: 'SD',
    text: 'South Dakota (SD)'
  },
  {
    value: 'TN',
    text: 'Tennessee (TN)'
  },
  {
    value: 'TX',
    text: 'Texas (TX)'
  },
  {
    value: 'UT',
    text: 'Utah (UT)'
  },
  {
    value: 'VT',
    text: 'Vermont (VT)'
  },
  {
    value: 'VA',
    text: 'Virginia (VA)'
  },
  {
    value: 'WA',
    text: 'Washington (WA)'
  },
  {
    value: 'WV',
    text: 'West Virginia (WV)'
  },
  {
    value: 'WI',
    text: 'Wisconsin (WI)'
  },
  {
    value: 'WY',
    text: 'Wyoming (WY)'
  }
]



// WEBPACK FOOTER //
// ./resources/js/util/usa-states.js